import { render, staticRenderFns } from "./CatalogRecordGrid.vue.js?vue&type=template&id=4c70795d&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogRecordGrid.vue?vue&type=template&id=4c70795d&scoped=true"
import script from "./CatalogRecordGrid.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogRecordGrid.vue?vue&type=script&lang=js"
export * from "./CatalogRecordGrid.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70795d",
  null
  
)

export default component.exports